module.exports = __webpack_public_path__ + "img/nav-btn-3.76b2fff4.svg";